module.exports = __webpack_public_path__ + "img/1.893c429d.jpg";